import React from "react";
import "./styles/FAQs.css"

export class FAQs extends React.Component{
    render() {
        return(
            <div className="faqs"></div>
        )
    }
}